import { render } from "./WhatsAppMetaPhoneNumberListItem.vue?vue&type=template&id=31fe4ea8&ts=true"
import script from "./WhatsAppMetaPhoneNumberListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppMetaPhoneNumberListItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/WhatsAppMetaPhoneNumberListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31fe4ea8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31fe4ea8', __exports__)) {
    api.reload('31fe4ea8', __exports__)
  }
  
  module.hot.accept("./WhatsAppMetaPhoneNumberListItem.vue?vue&type=template&id=31fe4ea8&ts=true", () => {
    api.rerender('31fe4ea8', render)
  })

}


export default __exports__